import { render, staticRenderFns } from "./SettingsDashboard.vue?vue&type=template&id=6fb6245c&scoped=true&lang=pug"
import script from "./SettingsDashboard.vue?vue&type=script&lang=js"
export * from "./SettingsDashboard.vue?vue&type=script&lang=js"
import style0 from "./SettingsDashboard.vue?vue&type=style&index=0&id=6fb6245c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6245c",
  null
  
)

export default component.exports